import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatCheckbox} from "@angular/material/checkbox";
import {TranslateModule} from "@ngx-translate/core";
import {
  LEGAL_CGU_URL,
  LEGAL_PRIVACY_URL,
} from "../../constants/legal-links.constants";

@Component({
  selector: "app-legal-acceptance-controls",
  templateUrl: "./legal-acceptance-controls.component.html",
  styleUrls: ["./legal-acceptance-controls.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MatCheckbox, TranslateModule],
})
export class LegalAcceptanceControlsComponent {
  @Input() form!: FormGroup;

  public readonly cguUrl = LEGAL_CGU_URL;
  public readonly privacyUrl = LEGAL_PRIVACY_URL;
}
